import React from "react";
import TicketNotesSection from "./notes/TicketNotesSection";
import CommercialNotesSection from "./notes/CommercialNotesSection";
import ReportsSection from "./notes/ReportsSection";

/*
Notes tab: internal notes, external notes and an optional report section.
Each part is gated the same way as its tab in
Warranties/SingleWarranty/SingleWarranty.js:
- Internal Notes (staff only) -> "Communications" tab (CommercialNotes):
  hidden for Contractor and Commercial roles
- External Notes              -> "Activity" tab (Activities/NoteItem.js):
  hidden for Commercial roles; Contractors see it read-only
- Reports                     -> "Repair Details" tab: hidden for Commercial
  roles
*/
const COMMERCIAL_ROLES = ["Commercial Staff", "Commercial Admin"];

const roleOf = function (userInfo) {
  return userInfo && userInfo.user && userInfo.user.role;
};

export const noteSectionsFor = function (userInfo) {
  const role = roleOf(userInfo);
  const isCommercial = COMMERCIAL_ROLES.includes(role);
  const isContractor = role === "Contractor";
  return {
    internalNotes: !isCommercial && !isContractor,
    externalNotes: !isCommercial,
    reports: false,
  };
};

// Commercial roles get no section, so TicketCaseDetail drops the tab.
export const canSeeNoteTab = function (userInfo) {
  const sections = noteSectionsFor(userInfo);
  return sections.internalNotes || sections.externalNotes || sections.reports;
};

const NoteTab = function (props) {
  const sections = noteSectionsFor(props.userInfo);
  return (
    <div className="tn-tabpanel">
      {sections.internalNotes ? (
        <CommercialNotesSection ticket={props.ticket} protectedFetch={props.protectedFetch} />
      ) : null}
      {sections.externalNotes ? (
        <TicketNotesSection
          ticket={props.ticket}
          protectedFetch={props.protectedFetch}
          userInfo={props.userInfo}
          reloadTicket={props.reloadTicket}
        />
      ) : null}
      {sections.reports ? <ReportsSection ticket={props.ticket} /> : null}
    </div>
  );
};

export default NoteTab;
